import React from 'react'
import NewUserSelectionCard from '@Components/Cards/NewUserSelectionCard'
import { ICONS } from '@Const/common'
import { useNavigate } from 'react-router'
import Navigation from '@App/navigation'

const NewMemberQuestions = () => {
    const navigate = useNavigate()
    return (
        <div className="user-options horizontal">
            <NewUserSelectionCard
                orientation="horizontal"
                icon={ICONS.publishingDealIcon}
                title="I am a Publisher"
                description={
                    <p>I manage the music administration for and collect royalties on behalf of songwriters.</p>
                }
                onClick={() =>
                    navigate(Navigation.registrationRightsholder.form(), { state: { memberType: 'Publisher' } })
                }
            />
            <NewUserSelectionCard
                orientation="horizontal"
                icon={ICONS.administratorBuildingIcon}
                title="I am an Administrator"
                description={
                    <p>I manage the music administration for and collect royalties on behalf of songwriters.</p>
                }
                onClick={() =>
                    navigate(Navigation.registrationRightsholder.form(), { state: { memberType: 'Administrator' } })
                }
            />
            <NewUserSelectionCard
                orientation="horizontal"
                icon={ICONS.cmoGlobeIcon}
                title="I am a CMO"
                description={<p>I collect and distribute royalties for songwriters.</p>}
                onClick={() => navigate(Navigation.registrationRightsholder.form(), { state: { memberType: 'CMO' } })}
            />
            <NewUserSelectionCard
                orientation="horizontal"
                icon={ICONS.personWithTie}
                title="I am a Manager/Lawyer/Other"
                description={
                    <p>I manage songwriters' taxes and handle any related business, legal, or other matters.</p>
                }
                onClick={() =>
                    navigate(Navigation.registrationRightsholder.form(), {
                        state: { memberType: 'Manager/Lawyer/Other' },
                    })
                }
            />
        </div>
    )
}
export default NewMemberQuestions
